"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnifiedTransactionType = void 0;
var UnifiedTransactionType;
(function (UnifiedTransactionType) {
    UnifiedTransactionType["PLAID"] = "plaid";
    UnifiedTransactionType["METHODFI"] = "methodFi";
})(UnifiedTransactionType || (exports.UnifiedTransactionType = UnifiedTransactionType = {}));
